const { useAuthContext } = require("app/contexts/auth");
const { useFormatosContext } = require("../formatos-context");
const {
  Paper,
  Stack,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  IconButton,
} = require("@mui/material");
const { MdOpenInNew } = require("react-icons/md");

export function FormatosTable() {
  const { token } = useAuthContext();

  const { formatos } = useFormatosContext();

  return (
    <Paper
      sx={{ padding: 1 }}
      className="animate__animated animate__fadeIn"
      variant="outlined"
    >
      <Stack>
        <Stack justifyContent="space-between" direction="row" padding={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h6">Formatos</Typography>
          </Stack>
        </Stack>

        {!!formatos.length ? (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {["#", "Nombre", "Opciones"].map((label, i) => (
                  <TableCell key={i}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {formatos.map((formato, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>{formato.title}</TableCell>

                  <TableCell align="center">
                    <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Tooltip title="Abrir">
                        <IconButton
                          color="default"
                          size="small"
                          onClick={async () => {
                            try {
                              // const response = await toast.promise(
                              //   axios.get(formato.url, {
                              //     params: {
                              //       accessToken: token,
                              //     },
                              //     responseType: "blob",
                              //     headers: {
                              //       Accept: "application/pdf",
                              //     },
                              //   }),
                              //   {
                              //     loading: "Abriendo formato...",
                              //     success: "Formato abierto",
                              //     error:
                              //       "¡Error al abrir el formato, por favor, intente de nuevo!",
                              //   }
                              // );

                              // const blob = new Blob([response.data], {
                              //   type: "application/pdf",
                              // });

                              // const url = window.URL.createObjectURL(blob);

                              return window.open(
                                `${formato.url}?accessToken=${token}`
                              );
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <MdOpenInNew />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" variant="overline">
            Sin Formatos
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
